module.exports = require('./readable').Transform



//////////////////
// WEBPACK FOOTER
// ./~/node-libs-browser/~/readable-stream/transform.js
// module id = 943
// module chunks = 0